import { create } from 'zustand';

import { type OrderKey, PROJECT_PAGE_SIZE, type ProjectStatus } from './projects';

interface ProjectsQueryState {
  search: string;
  status: 'All' | ProjectStatus;
  order: OrderKey;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setStatus: (status: 'All' | ProjectStatus) => void;
  setOrder: (order: OrderKey) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<ProjectsQueryState, 'search' | 'status' | 'order' | 'page' | 'pageSize'> = {
  search: '',
  status: 'All',
  order: 'newest',
  page: 1,
  pageSize: PROJECT_PAGE_SIZE,
};

/**
 * Query state for the projects list (search, filter, sort, pagination).
 * Kept outside the component so it survives navigation. Cached data lives in
 * the resource cache (`useProjects` / `useResource`), not here.
 */
export const useProjectsStore = create<ProjectsQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  setOrder: (order) => set({ order, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
